import React from 'react';
import { Sparkles, Check } from 'lucide-react';

const features = [
  'Personalized meal plans',
  'Macro tracking & analysis',
  'Recipe database access',
  'Nutrition coaching',
  'Weekly meal prep guides'
];

export function PremiumPlan() {
  return (
    <div className="theme-card p-6 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-primary to-transparent rounded-full blur-3xl" />
      </div>
      
      <div className="relative">
        <div className="flex items-center gap-3 mb-4">
          <div className="relative">
            <Sparkles className="w-6 h-6 text-primary" />
            <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
          </div>
          <h2 className="text-xl font-semibold">Premium Nutrition</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <p className="text-muted-foreground mb-4">
              Unlock advanced nutrition features and personalized guidance to reach your goals faster.
            </p>
            <ul className="space-y-2">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center gap-2">
                  <div className="w-5 h-5 rounded-full bg-primary/20 flex items-center justify-center">
                    <Check className="w-3 h-3 text-primary" />
                  </div>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="flex flex-col justify-center items-center text-center p-6 bg-muted/30 rounded-lg">
            <div className="text-3xl font-bold mb-2">₹999/month</div>
            <div className="text-muted-foreground mb-4">Cancel anytime</div>
            <button className="theme-button px-8 py-3 rounded-lg w-full">
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}